<template>
  <div>
    <slot v-if="item.status == 'yard'">
      <slot v-if="item.operation.status != 'bare_chassis'">
        {{ item.ssline.name }}
      </slot>
    </slot>
    <slot v-else>
      {{ item.ssline.name }}
    </slot>
  </div>
</template>

<script>
export default {
  name: "order-status-ssline",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
